<template>
  <div class="px-4 sm:px-5 lg:px-5 mt-5 max-w-4xl">
    <div class="sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <h1 class="text-xl font-semibold text-gray-900">{{ $t('flow.groups') }}</h1>
        <p class="mt-2 text-sm text-gray-700">{{ $t('flow.headline') }}</p>
      </div>
      <button v-on:click="toggleAddModal" class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto">
        {{ $t('flow.add') }}
      </button>
    </div>
    <div class="mt-5 overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
      <table class="min-w-full divide-y divide-gray-300">
        <thead class="bg-gray-50">
          <tr>
            <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">{{ $t('flow.name') }}</th>
            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">{{ $t('flow.agents') }}</th>
            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">{{ $t('flow.conversations') }}</th>
            <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
              <span class="sr-only">Actions</span>
            </th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 bg-white">
          <tr v-for="group of groupStore.collection" v-bind:key="group.id">
            <groupListItem :group="group" v-on:delete-event="getExistingGroups" v-on:edit-event="getExistingGroups" />
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="px-4 sm:px-5 lg:px-5 mt-5 max-w-4xl mt-12 mb-5">
    <div class="sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <h1 class="text-xl font-semibold text-gray-900">{{ $t('flow.reasonsForResolving') }}</h1>
        <p class="mt-2 text-sm text-gray-700">{{ $t('flow.reasonsForResolvingLabel') }}</p>
      </div>
      <button v-on:click="toggleReasonAddModal" class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto">
        {{ $t('flow.addReason') }}
      </button>
    </div>
    <div class="mt-5 overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
      <table class="min-w-full divide-y divide-gray-300">
        <thead class="bg-gray-50">
          <tr>
            <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">{{ $t('flow.reason') }}</th>
            <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
              <span class="sr-only">Actions</span>
            </th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 bg-white">
          <tr v-for="reason of reasonStore.collection" v-bind:key="reason.id">
            <ReasonListItem :reason="reason" v-on:delete-event="getExistingReasons" v-on:edit-event="getExistingReasons" />
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <groupAdd v-if="showAdd" v-on:add-finished-event="toggleAddModal" />
  <ReasonAdd v-if="showReasonAdd" v-on:add-finished-event="toggleReasonAddModal" />
</template>
<script>

import { useGroupStore } from '@/stores/groups';
import groupModel from '../../models/group'
import groupListItem from "@/components/settings/flow/GroupListItem";
import groupAdd from "@/components/settings/flow/GroupAdd";

import { useReasonForResolvingStore } from '@/stores/reasonForResolving';
import reasonModel from '../../models/reason'
import ReasonListItem from "@/components/settings/flow/ReasonListItem";
import ReasonAdd from "@/components/settings/flow/ReasonAdd";


export default {
  name: 'FlowPage',
  setup() {
    let groupStore = useGroupStore();
    let reasonStore = useReasonForResolvingStore();
    return { groupStore, reasonStore };
  },
  components: {
    groupListItem,
    groupAdd,
    ReasonListItem,
    ReasonAdd,
  },
  created() {
    this.getExistingGroups();
    this.getExistingReasons();
  },
  methods: {
    async getExistingGroups() {
      return await groupModel.getExistingGroups(this.axios, this.groupStore, this.$root.token);
    },
    async getExistingReasons() {
      return await reasonModel.getExistingReasons(this.axios, this.reasonStore, this.$root.token);
    },
    toggleAddModal() {
      this.showAdd = !this.showAdd;
    },
    toggleReasonAddModal() {
      this.showReasonAdd = !this.showReasonAdd;
    },
  },
  data() {
    return {
      showAdd: false,
      showReasonAdd: false,
    }
  },
}
</script>
